import axios from "axios";

type CreateAdminActionProps = {
  email: string;
};

export async function createAdminAction({ email }: CreateAdminActionProps) {
  const token = localStorage.getItem("token");

  const dataToSend = {
    emailAddress: email,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/user/registration`,
      dataToSend,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
